export class PaymentConditionOption {

  identifier: string;
  minValue: number;
  installments: number;
  name: string;
  installmentValue: number;
  formatted: string;

  constructor(paymentConditionOptionData: any) {
    this.identifier = paymentConditionOptionData.identifier;
    this.minValue = paymentConditionOptionData.minValue;
    this.installments = paymentConditionOptionData.installments;
    this.name = paymentConditionOptionData.name;
    this.installmentValue = paymentConditionOptionData.installmentValue;
    this.formatted = '';
  }

}
